import Pharmacy from "./PharmacyList";
export default Pharmacy;
